module.exports = __webpack_public_path__ + "img/discussion_dark.4e75fa91.svg";